import React from 'react';
import { Button } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';

export default function ResetFieldButton({ onClick }: { onClick: () => void }) {
  return (
    <Button
      size="small"
      type="link"
      icon={<ReloadOutlined />}
      onClick={onClick}
    >
      Reset field
    </Button>
  );
}
